import React, { useEffect } from "react";
import { ITextInputComponent, SWTypes } from "interfaces/sw/SWInterfaces";
import { useDispatch } from "react-redux";
import { updateTextInput } from "store/manageSW/manageSWActions";
import "./TextInputEditor.scoped.scss";
import useSelector from "store/useSelector";
import { loadMeters } from "store/masterData/masterDataActions";
import SelectMeter from "./SelectMeter";
import { IEpicEquipmentMasterDataItem } from "interfaces/masterData/masterDataInterfaces";

interface ITextInputEditorProps {
  textInput: ITextInputComponent,
  allowEdit: boolean,
  stepGuid: string,
  labelText: string,
  swType: SWTypes,
  stepLocation?: string,
}

const TextInputEditor: React.FC<ITextInputEditorProps> = ({
  textInput,
  allowEdit,
  stepGuid,
  labelText,
  swType,
  stepLocation,
}) => {
  const {
    masterData: {
      meters,
    },
    manageSW: {
      enableMetersValue,
      SW: {
        epicEquipment,
        events,
        maintenanceTasks,
      }
    },

  } = useSelector((store) => store);
  const dispatch = useDispatch();
  const epicEquip = (swType === SWTypes.TLMSWI
    && events
    && events.length > 0
    && events[0].code === "FCO"
    && maintenanceTasks
    && maintenanceTasks.length > 0
    && maintenanceTasks[0].equipmentCodes)
    ? maintenanceTasks[0].equipmentCodes.split(",").map((item: any): IEpicEquipmentMasterDataItem => ({
      guid: item,
      owningOrgCode: "",
      value: item,
      code: item,
      active: true,
    }))
    : epicEquipment;

  useEffect(() => {
    if (epicEquip.length > 0) {
      dispatch(loadMeters({ onlyActive: true, equipmentCodes: epicEquip, location: "1:Global" }));
    }
  }, [epicEquip]);

  const filterMeters = stepLocation === undefined || stepLocation === null || stepLocation === "" || stepLocation === "1:Global" ? meters.items : meters.items.filter(t => t.parentGuid === stepLocation);

  return (
    <div className="component-editor">
      <div className="row">
        <label className="mandatory block">{labelText}</label>
        {(enableMetersValue && (swType === SWTypes.TLMSWI || swType === SWTypes.TLMRC)) &&
          <label className="meter">Meter</label>}
      </div>
      <div className="row">
        {allowEdit &&
          <>
            <input
              type="text"
              defaultValue={textInput.label}
              onBlur={(e) => dispatch(updateTextInput({
                stepGuid,
                component: {
                  ...textInput,
                  label: e.target.value,
                }
              }))}
            />
            {(enableMetersValue && (swType === SWTypes.TLMSWI || swType === SWTypes.TLMRC)) &&
              <div className="meter">
                <SelectMeter
                  inputComponent={textInput}
                  stepGuid={stepGuid}
                  meters={filterMeters} />
              </div>
            }
          </>
        }
        {!allowEdit &&
          <>
            <span>{textInput.label}</span>
            {(enableMetersValue && (swType === SWTypes.TLMSWI || swType === SWTypes.TLMRC)) &&
              <span className="meter">{textInput.meterCode}</span>}
          </>
        }
      </div>
    </div>
  );
}

export default TextInputEditor;